var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"globeContainer",staticClass:"globeContainer"},[_c('canvas',{ref:"globe",attrs:{"width":"700","height":"655"}})])}
var staticRenderFns = []

export { render, staticRenderFns }